export const ADVISORY_ROLES = [
  'admin',
  'advisor',
  'manager',
  'reader',
  'editor'
]

export const CLIENT_ROLES = ['customer']

export const PRESENTER_ROLES = ['cabp_presenter']

export const STATISTICS_ONLY_ROLES = ['cabp_statistics']

export const checkAdvisoryRole = userRoles => {
  return checkRole(userRoles, ADVISORY_ROLES)
}

export const checkPresenterRole = userRoles => {
  return checkRole(userRoles, PRESENTER_ROLES)
}

export const checkStatisticsOnlyRole = userRoles => {
  return checkRole(userRoles, STATISTICS_ONLY_ROLES)
}

const checkRole = (userRoles, rolesList) => {
  for (const r of userRoles) {
    if (rolesList.indexOf(r) !== -1) return true
  }
  return false
}
